import React from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { ui } from './styles';

export function PageShell({ children, withToaster = false }) {
  return (
    <div className={ui.page}>
      {withToaster && <Toaster position="top-right" />}
      {children}
    </div>
  );
}

export function PageHeader({ title, description, actions, user }) {
  return (
    <div className={ui.header}>
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <h1 className={ui.headerTitle}>{title}</h1>
          {description && <p className={ui.headerDescription}>{description}</p>}
        </div>
        {(actions || user) && (
          <div className="flex items-center gap-3">
            {user && (
              <div className="hidden items-center gap-3 rounded-2xl border border-border bg-slate-50 px-3 py-2 sm:flex">
                <div className="flex h-9 w-9 items-center justify-center rounded-full bg-primary text-sm font-semibold text-white">
                  {user.initials}
                </div>
                <div>
                  <div className="text-sm font-medium text-text">{user.name}</div>
                  <div className="text-xs text-muted">{user.role}</div>
                </div>
              </div>
            )}
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}

export function Panel({ children, className = '' }) {
  return <section className={`${ui.panel} ${className}`}>{children}</section>;
}

export function MetricCard({ icon: Icon, label, value, tone = 'primary' }) {
  const tones = {
    primary: 'bg-primary-light text-primary',
    success: 'bg-emerald-50 text-emerald-600',
    warning: 'bg-amber-50 text-amber-600',
    danger: 'bg-red-50 text-red-600',
    info: 'bg-sky-50 text-sky-600',
  };

  return (
    <div className={ui.metricCard}>
      <div className="mb-4 flex items-center justify-between">
        <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${tones[tone]}`}>
          {Icon && <Icon size={18} />}
        </div>
      </div>
      <div className="text-3xl font-semibold tracking-tight text-text">{value}</div>
      <div className="mt-1 text-sm text-muted">{label}</div>
    </div>
  );
}

export function StatusBadge({ children, tone = 'neutral' }) {
  const tones = {
    success: ui.badgeSuccess,
    warning: ui.badgeWarning,
    danger: ui.badgeDanger,
    neutral: ui.badgeNeutral,
  };

  return <span className={`${ui.badge} ${tones[tone]}`}>{children}</span>;
}

export function LoadingState({ message = 'Carregando...' }) {
  return (
    <div className="flex items-center justify-center gap-3 py-10 text-muted">
      <div className={ui.spinner} />
      <span>{message}</span>
    </div>
  );
}

export function EmptyState({ message, hint }) {
  return (
    <div className="py-10 text-center">
      <p className="text-sm font-medium text-text">{message}</p>
      {hint && <p className="mt-1 text-sm text-muted">{hint}</p>}
    </div>
  );
}

export { toast };
